interface CityBadgeProps {
  name: string;
  className?: string;
}

export function CityBadge({ name, className }: CityBadgeProps) {
  return (
    <div className={`relative inline-block -rotate-3 ${className ?? ""}`}>
      <span
        className="inline-block scale-x-90 origin-left font-sans font-extrabold text-3xl  tracking-[-0.5px] text-[#0c3152]"
        style={{
          textShadow:
            "1.5px 0 0 #fff, -1.5px 0 0 #fff, 0 1.5px 0 #fff, 0 -1.5px 0 #fff, 1.5px 1.5px 0 #fff, -1.5px -1.5px 0 #fff, 1.5px -1.5px 0 #fff, -1.5px 1.5px 0 #fff, 2.6px 1.1px 0 #fff, -2.6px 1.1px 0 #fff, 2.6px -1.1px 0 #fff, -2.6px -1.1px 0 #fff, 1.1px 2.6px 0 #fff, -1.1px 2.6px 0 #fff, 1.1px -2.6px 0 #fff, -1.1px -2.6px 0 #fff, 4px 5px 6px rgba(0,0,0,0.28)",
        }}
      >
        {name}
      </span>
      <div className="absolute left-0.5 -bottom-1.5 w-3.5 h-1.25 bg-[#ef9f27] rounded -rotate-2" />
    </div>
  );
}
